const _excluded = ["onChange"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.iterator.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { Dropdown } from '@isyc-react/design/overlays';
import { MediaDevices } from "../../../devices";
import { Ripple } from '@isyc-react/animation/modules/base/transition';
import { RippleButton } from '@isyc-react/form/modules/base/button';
import '@isyc-react/design/main';
import "../../camera.style.scss";
export const CameraConfigButton = props => {
  const {
      onChange
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const [show, setShow] = React.useState(false);
  return /*#__PURE__*/React.createElement(Dropdown, {
    alignEnd: true,
    show: show,
    onToggle: nextShow => setShow(nextShow),
    drop: 'left'
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, null, (toggleProps, meta) => /*#__PURE__*/React.createElement(RippleButton, _extends({}, toggleProps, {
    onClick: () => meta.toggle(!show),
    className: "btn-media-camera config"
  }), /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-dots-vertical"
  }), /*#__PURE__*/React.createElement(Ripple, null))), /*#__PURE__*/React.createElement(Dropdown.Menu, {
    flip: false,
    offset: [0, 10]
  }, (menuProps, meta) => /*#__PURE__*/React.createElement("div", _extends({}, menuProps, {
    className: "media-camera-config-container"
  }), /*#__PURE__*/React.createElement(MediaDevices, _extends({}, rest, {
    onChange: change => {
      meta.toggle && meta.toggle(!meta.show);
      onChange && onChange(change);
    }
  })))));
};